import axios from "axios";
import {LinkPayment} from "../types";
import {formatCpfOrCnpj, formatDocumentType, formatParcels, formatPaymentDate, formatStatus} from "../utils";
import config from "../../../config";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { FormValues } from "../../terminaisPhoebus/types";
import { getAxiosInstanceLinkPagamento } from "../../../services/providers/api";
import { BaseService } from "../../../global/classes";

export default class LinkDePagamentoService extends BaseService {
  /**
   * O serviço de link valida o JWT da API antiga, não o do VAULT. Isto lia
   * `accessToken` direto, que era o token legado até o login passar pelo VAULT —
   * de lá para cá virou o token do VAULT e toda chamada de link voltava 401.
   */
  getTokenFromLocalStorage = () => this.legacyAccessToken;

  getMerchantIdFromLocalStorage = () => {
    let selectedCompany: any = localStorage.getItem('selectedCompany');
    if (selectedCompany) {
      selectedCompany = JSON.parse(selectedCompany);
      return selectedCompany.merchantId as string;
    }
    return null;
  }

  getBusinessIdFromLocalStorage = () => {
    let selectedCompany: any = localStorage.getItem('selectedCompany');
    if (selectedCompany) {
      selectedCompany = JSON.parse(selectedCompany);
      return selectedCompany.id as number;
    }
    return null;
  }

  getThreeDSEnabledFromLocalStorage = () => {
    let selectedCompany: any = localStorage.getItem('selectedCompany');
    if (selectedCompany) {
      selectedCompany = JSON.parse(selectedCompany);
      return selectedCompany.threeDSEnabled as boolean;
    }
    return null;
  }

  createLink = async (data: any) => {
    const parsedToken = this.getTokenFromLocalStorage();
    const merchantId = this.getMerchantIdFromLocalStorage();
    const businessId = this.getBusinessIdFromLocalStorage();

    data.three_ds_enabled = this.getThreeDSEnabledFromLocalStorage();

    try {
      await axios.post(`${config.wlBaseurl}/link-pagamento/criar/${merchantId}`, {...data},
        {
          headers: {
            Authorization: `Bearer ${parsedToken?.token}`,
          },
          params: {
            businessId: businessId
          }
        })
    } catch (error) {
      throw error;
    }
  }

  getLinkDePagamentoById = async (id: string) => {
    const parsedToken = this.getTokenFromLocalStorage();

    try {
      const response = await axios.get(`${config.wlBaseurl}/link-pagamento/pagamentos/listar/${id}`, {
        headers: {
          Authorization: `Bearer ${parsedToken?.token}`
        }
      });
      return response.data;
    } catch(error) {
      throw error;
    }
  }

  getAllLinks = async (selectedBusiness: any, user:any) => {
    const parsedToken = this.getTokenFromLocalStorage();

    try {
      const response = await axios.get(`${config.wlBaseurl}/link-pagamento/listar/${selectedBusiness.merchantId}/${user.id}`, {
        headers: {
          Authorization: `Bearer ${parsedToken?.token}`
        }
      });

      return response.data;

    } catch (error) {
      throw error;
    }
  }

  deleteLinkById = async (id: string) => {
    const parsedToken = this.getTokenFromLocalStorage();

    try {
      const response = await axios.delete(`${config.wlBaseurl}/link-pagamento/deletar/${id}`, {
        headers: {
          Authorization: `Bearer ${parsedToken?.token}`
        }
      });

      return response.status;
    } catch (error) {
      throw error;
    }
  }

  getTransactionPdf = async (
    transaction: LinkPayment
  ) => {
    // Único método da classe que vai para a API antiga, e não para o serviço de
    // link — mas o token é o mesmo legado nos dois casos: o serviço de link também
    // valida o JWT da API antiga, e não o do VAULT.
    const parsedToken = this.legacyAccessToken;

    const value = Number(transaction.value) / 100;
    const status = formatStatus(transaction.status);
    const parcels = formatParcels(Number(transaction.parcels));
    const documentType = formatDocumentType(transaction.merchantNationalId);
    const paymentDate = formatPaymentDate(transaction.paymentDate);

    try {
      const response = await axios.get(`${config.apiBaseUrl}/link-pagamento/get-transaction-pdf`, {
        params: {
          merchantId: transaction.merchant,
          businessName: transaction.businessName,
          document: formatCpfOrCnpj(transaction.merchantNationalId),
          value: value,
          paymentType: transaction.productName,
          parcels: parcels,
          brand: transaction.brand,
          cardNumber: transaction.cardNumber,
          nsu: transaction.acquirerNSU,
          paymentDate: paymentDate,
          captureChannel: transaction.captureChannel,
          paymentAuthorization: transaction.authorizationNumber,
          paymentStatus: status,
          documentType: documentType
        },
        headers: {
          Authorization: `Bearer ${parsedToken?.token}`
        },
        responseType: 'blob'
      });

      return response.data;
    } catch(error) {
      throw error;
    }
  }

  async downloadRelatorioLinks() {
  const selectedCompany = JSON.parse(localStorage.getItem("selectedCompany") || "{}");
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const merchantId = selectedCompany.merchantId;
  const userId = userInfo.id;

  try {
    const response = await getAxiosInstanceLinkPagamento().get(
      `link-pagamento/downloadRelatorioLinks/${userId}/${merchantId}`
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "relatorio_links.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Erro ao gerar o relatório de links:", error);
  }
}

}
